/**
 * Date formatting utilities for consistent DD/MM/YYYY format across the application
 */

/**
 * Format date as DD/MM/YYYY
 * @param {Date|string|null} date - Date to format
 * @returns {string|null} Formatted date string or null
 */
export const formatDate = (date) => {
  if (!date) return null
  return new Date(date).toLocaleDateString('en-GB')
}

/**
 * Format datetime as DD/MM/YYYY HH:MM
 * @param {Date|string|null} date - Date to format
 * @returns {string|null} Formatted datetime string or null
 */
export const formatDateTime = (date) => {
  if (!date) return null
  return new Date(date).toLocaleString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

/**
 * Format date as DD/MM/YYYY HH:MM:SS
 * @param {Date|string|null} date - Date to format
 * @returns {string|null} Formatted datetime string with seconds or null
 */
export const formatDateTimeFull = (date) => {
  if (!date) return null
  return new Date(date).toLocaleString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  })
}

/**
 * Format time only as HH:MM
 * @param {Date|string|null} date - Date to format
 * @returns {string|null} Formatted time string or null
 */
export const formatTime = (date) => {
  if (!date) return null
  return new Date(date).toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit'
  })
}

/**
 * Format date for input fields (YYYY-MM-DD)
 * @param {Date|string|null} date - Date to format
 * @returns {string} Formatted date string for input or empty string
 */
export const formatDateForInput = (date) => {
  if (!date) return ''
  const d = new Date(date)
  return d.toISOString().split('T')[0]
}

/**
 * Format datetime for input fields (YYYY-MM-DDTHH:MM)
 * @param {Date|string|null} date - Date to format
 * @returns {string} Formatted datetime string for input or empty string
 */
export const formatDateTimeForInput = (date) => {
  if (!date) return ''
  const d = new Date(date)
  return d.toISOString().slice(0, 16)
}
